import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../../Optics/Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';

import { UpdateHighwayLine,   UpdateHighwayLineLengthAct, UpdateHighwayLineCable, UpdateContractor,
  UpdateTypeCable,
  UpdateRankCable } from '../../../../Optics/UpdateData/UpdateCommunications';

import { CONST_AIR, CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR, CONST_BASEMENT, CONST_CANTON, CONST_FACADE, CONST_LOFT, CONST_SUBWAY, ROLE_SENIOR_MASTER } from '../../../../Optics/Constants/ConstantsOptics';
import { loadingCableDataComponent, loadingCableTypeDataComponent, loadingCassetteDataComponent, loadingPolishingDataComponent, loadingRankCableDataComponent } from '../../../../Optics/LoadingData/LoadingDataComponents';
import {  UpdateLineEtherComponents, UpdateLineKtvComponents, UpdateLinePonComponents, UpdateStatusComponents } from '../../../../Optics/UpdateData/UpdateStatusComponent';

import { loadingContractorDataComponent } from '../../../../Optics/LoadingData/LoadingDataComponents';
import { CABLE } from '../../../../Optics/Constants/ConstantsOptics';
import { TerritoryLabel } from '../../../../Optics/Dialog/DialogDescriptionComponent/TerritoryLabel ';
import Select from 'react-select';
import { DeleteCableConstruction, UpdateCableConstruction, UpdateCableDescriptionConstruction, UpdateCableLengthActConstruction, UpdateCassettePatchConstruction, UpdateContractorConstruction, UpdateForwardingConstruction, UpdateRankCableConstrucyion, UpdateTypeCableConstruction } from '../../../WriteData/UpdateConstructCommunications';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff', 
    width: '230px',
    marginLeft: '-10px',
    marginRight: '-13px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const CableDescriptEditingModal = ({ open, onClose, onClose2, content, changeLinkEditing, cantonRefresh, cantonCablaByIdRefresh }) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [textLengthAct, setTextLengthAct] = useState(content.lengthAct);
  const [statusChange, setStatusChange] = useState(false);
  const [statusChangeLengthAct, setStatusChangeLengthAct] = useState(false);
  
  const [cableData, setCableData] = useState([]);
  const [selectedFiberQuantity, setSelectedFiberQuantity] = useState(content.cableFiberQuantity);
  const [cableLineId, setCableLineId] = useState("");
  const [contractorData, setContractorData] = useState([]);
  const [rankCablaData, setRankCableData] = useState([]);
  const [rankCableId, setRankCableId] = useState("");
  const [typeCableData, setTypeCableData] = useState([]);
  const [typeCableId, setTypeCableId] = useState("");
  const [contractorId, setContractorId] = useState("");
  const [forwardingCount, setForwardingCount] = useState(content.forwardingCount);
  const [statusChangeForwarding, setStatusChangeForwarding] = useState(false);
  const [selectedCassetteModel, setSelectedCassetteModel] = useState(content.cassetteId);
  const [selectedPolishingPatch, setSelectedPolishingPatch] = useState(content.polishingPatchId);
  const [polishingData, setPolishingData] = useState([]);
  const [patchCableCount, setPatchCableCount] = useState(content.patchCount);
  const [cassetteCableCount, setCassetteCableCount] = useState(content.cassetteCount);
  const [cassetteData, setCassetteData] = useState([]);
  

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cableData, contractorData, typeCableData, rankCablaData, polishingData, cassetteData] = await Promise.all([
          loadingCableDataComponent(),
          loadingContractorDataComponent(),
          loadingCableTypeDataComponent(),
          loadingRankCableDataComponent(),
          loadingPolishingDataComponent(),
          loadingCassetteDataComponent(),
        ]);
        setCableData(cableData);
        setContractorData(contractorData);
        setTypeCableData(typeCableData);
        setRankCableData(rankCablaData);
        setPolishingData(polishingData);
        setCassetteData(cassetteData);
      } catch (error) {
        // Обработка ошибок (если нужна)
        // console.error("Error in fetchData:", error);
      }
    };
  
    fetchData();
  }, []);

  const options = cableData.map(cable => ({
    value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
    label: cable.name,
    group: cable.cableGroupId === 4 ? "Неизвестно" : cable.cableGroupId === 3 ? "Воздушка" : "Подземка",

  }));
  
  // Группировка опций
  const groupedOptions = [
    {
      label: "Воздушка",
      options: options.filter(option => option.group === "Воздушка"),
    },
    // показываем "Подземка" только если роль НЕ senior master
    {
      label: "Подземка",
      options: options.filter(option => option.group === "Подземка"),
    },
    {
      label: "Неизвестно",
      options: options.filter(option => option.group === "Неизвестно"),
    },
  ];
 

  const handleChangeCableSelect = (selectedOption) => {
    if (!selectedOption) {
      // Если выбор сброшен
      setCableLineId("");
      setSelectedFiberQuantity(null);
      return;
    }
  
    const selectedCableValue = selectedOption.value; // Значение выбранной опции
  
    // Находим соответствующий объект из cableData
    const selectedCable2 = cableData.find(cable => 
      `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}` === selectedCableValue
    );
  
    if (selectedCable2) {
      setSelectedFiberQuantity(selectedCable2.fiberQuantity);
      setCableLineId(selectedCable2.id);
    }
  };


  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };

const handleLengthActChange = (event) => {
  const newText = event.target.value;
  setTextLengthAct(newText);

  if (newText !== content.lengthAct) {
    setStatusChangeLengthAct(true);
  } else {
    setStatusChangeLengthAct(false);
  }
};

 const handleClickEditLink = () => {
  changeLinkEditing(content.id, true, CONST_CANTON);
};

const deleteLink = () => {
  DeleteCableConstruction( content.id, showSnackbar,  cantonRefresh, handleCloseDialogs );
};

const updateHighwayLineLengthAct = () => {
  if (statusChangeLengthAct) {
    UpdateCableLengthActConstruction(content.id, textLengthAct, showSnackbar,content.authorId, cantonRefresh );
  } else {
    showSnackbar('Нет нужды в записи, длина без изменений!', 'snackbarOk');
  }
};
 
  const updateHighwayLineDescription = () => {
    if (statusChange) {
      UpdateCableDescriptionConstruction(content.id, textComment, showSnackbar,content.authorId, cantonRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const updateCable = () => {
    if (cableLineId === "") {
      showSnackbar('Нет нужды в записи, кабель без изменений!', 'snackbarOk');
    } else {
      UpdateCableConstruction(content.id, cableLineId, showSnackbar,content.authorId, cantonRefresh, cantonCablaByIdRefresh );
    }
  };

  const handleChangeContractorSelect = (event) => {
    const selectedContractor = event.target.value;
    if (selectedContractor === "") {
      setContractorId("");
    } else {
      const selectedContractor2 = contractorData.find(contractor => 
        `${contractor.id}` === selectedContractor
      );
      if (selectedContractor2) {
        setContractorId(selectedContractor2.id);  
      }
    }
  };


  const handleChangeTypeCableSelect = (event) => {
    const selectedType = event.target.value;
  
    if (selectedType === "") {
      setTypeCableId(""); 
    } else {
     
      const [selectedId] = selectedType.split(",");
      const selectedType2 = typeCableData.find(
        (type) => `${type.id}` === selectedId
      );
  
      if (selectedType2) {
        setTypeCableId(selectedType2.id); 
      }
    }
  };

  const handleChangeRankCableSelect = (event) => {
    const selectedRank = event.target.value;
  
    if (selectedRank === "") {
      setRankCableId(""); 
    } else {
     
      const [selectedId] = selectedRank.split(",");
      const selectedRank2 = rankCablaData.find(
        (rank) => `${rank.id}` === selectedId
      );
  
      if (selectedRank2) {
        setRankCableId(selectedRank2.id); 
      }
    }
  };

  const handleForwardingChange = (event) => {
    const forwarding = event.target.value;
    setForwardingCount(forwarding);

    if (forwarding !== content.forwardingCount) {
      setStatusChangeForwarding(true);
    } else {
      setStatusChangeForwarding(false);
    }
  };

    const updateForwarding = () => {
    if (statusChangeForwarding) {
      UpdateForwardingConstruction(content.id, forwardingCount, showSnackbar,content.authorId, cantonRefresh );
    } else {
      showSnackbar('Нет нужды в записи, без изменений!', 'snackbarOk');
    } 
  };

  
  const updateContractor = () => {
    if (contractorId === "") {
      showSnackbar('Нет нужды в записи, подрядчик без изменений!', 'snackbarOk');
    } else {
      UpdateContractorConstruction(content.id, contractorId, showSnackbar,content.authorId, cantonRefresh,cantonCablaByIdRefresh );
    } 
  };

  const updateTypeCable = () => {
    if (typeCableId === "") {
      showSnackbar('Нет нужды в записи, тип без изменений!', 'snackbarOk');
    } else {
      UpdateTypeCableConstruction(content.id, typeCableId, showSnackbar,content.authorId, cantonRefresh );
    } 
  };

  const updateRankCable = () => {
    if (rankCableId === "") {
      showSnackbar('Нет нужды в записи, тип без изменений!', 'snackbarOk');
    } else {
      UpdateRankCableConstrucyion(content.id, rankCableId, showSnackbar,content.authorId, cantonRefresh );
    } 
  };

  const updateCassettePatch = () => {
       UpdateCassettePatchConstruction(content.id, selectedCassetteModel,cassetteCableCount, selectedPolishingPatch, patchCableCount, showSnackbar,content.authorId,cantonCablaByIdRefresh );
     
  };


    return (
      <Dialog open={open} className="dialogStyle">    
      <DialogContent>
      <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset', textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>Редактирование кабеля</label>
        <hr className='horizontalLineDialog'/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.id}</span></label>
        <br/>
          <TerritoryLabel content={content} />
        <hr className='horizontalLineDialog2'/>
         
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '-20px' }}>
       
          <label style={{ color: '#292929', fontWeight: 'bold'}}>Кабель: </label>

          <Select
              options={groupedOptions}
              onChange={(selectedOption) => handleChangeCableSelect(selectedOption)}
              placeholder={content.cableName || "Выберите кабель"}
              styles={customStyles}
              isClearable
            />
            <button onClick={updateCable} class='buttonIsSaveDialog2'>Сохранить</button>
            
            </div>

            <br/>
        <label style={{ color: '#292929', fontWeight: 'bold' }}>Количество волокон: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedFiberQuantity}</span></label>
        <br/>

        <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeTypeCableSelect(event);
          }} >
          <option value="">{content.cableTypeType}</option>
          {typeCableData.map(type => (
             
              <option key={type.id} value={type.id}>{type.type}</option>
         
          ))}
        </select>
        <button onClick={updateTypeCable} class='buttonIsSaveDialog2'>Сохранить</button>

        <br/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Длина кабеля: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.lengthCable} м.</span></label>
        <br/>
          {[CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR, CONST_BASEMENT, CONST_FACADE, CONST_LOFT].includes(content.cableTypeType) && (
            <>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (факт): </label>
                  
              <input
                type='number'
                className='textInput2EditingModal'
                value={textLengthAct} 
                min={0}
                onChange={handleLengthActChange} 
              /> м.
              <button onClick={updateHighwayLineLengthAct} class='buttonIsSaveDialog2'>Сохранить</button>
                <br/>
              </>
            )}
          {content.cableTypeType != CONST_SUBWAY && (
               <>
             <label style={{ color: '#292929', fontWeight: 'bold' }}>Пробросов: </label>
       
              <input
                type='number'
                className='textInput2EditingModal'
                value={forwardingCount} 
                min={0}
                onChange={handleForwardingChange} 
              /> 
                <button onClick={updateForwarding} class='buttonIsSaveDialog2'>Сохранить</button>
                 <br/>
             </>
          )}
             
        <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeRankCableSelect(event);
          }} >
          <option value="">{content.rankCableName}</option>
          {rankCablaData
          
            .map(rank => (
              <option key={rank.id} value={rank.id}>{rank.name}</option>
            ))}
        </select>
        <button onClick={updateRankCable} class='buttonIsSaveDialog2'>Сохранить</button>

        <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Подрядчик:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeContractorSelect(event);
          }} >
          <option value="">{content.contractorName}</option>
          {contractorData.map(contractor => (
            <option key={contractor.id} value={contractor.id}>{contractor.name}</option>
          ))}
        </select>
        <button onClick={updateContractor} class='buttonIsSaveDialog2'>Сохранить</button>

       




         {content.cableTypeType != CONST_SUBWAY && (
               <>
                  <hr className='horizontalLineDialog2'/>
                <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
                <label className="textTitleDrawer" style={{fontSize: '16px'}}>Кассета:</label>
                  <select
                    className="selectStyleDrawer"
                    style={{ marginLeft: '10px', marginRight:'5px' }}
                    value={selectedCassetteModel}
                    onChange={(e) => setSelectedCassetteModel(e.target.value)}
                  >
                    <option value="8">Модель</option>
                    {cassetteData.map(option => (
                      <option key={option.id} value={option.id}>{option.model}</option>
                    ))}
                  </select>


                  <input
                    type="number"
                    placeholder="кол."
                    style={{width: '60px'}}
                    className="textInput2EditingModal"
                    value={cassetteCableCount}
                      onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        if (value >= 0 || e.target.value === '') {
                          setCassetteCableCount(e.target.value);
                        }
                      }}
                  />
                  <label className="textTitleDrawer" style={{fontSize: '16px', marginLeft:'5px'}}>шт.</label>
                  <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px"}}/>
                    <label className="textTitleDrawer" style={{fontSize: '16px'}}>Патчкорд:</label>
                  <select
                    className="selectStyleDrawer"
                    style={{ marginLeft: '5px', marginRight:'5px'}}
                    value={selectedPolishingPatch}
                    onChange={(e) => setSelectedPolishingPatch(e.target.value)}
                  >
                    <option value="3">Полировка</option>
                    {polishingData.map(option => (
                      <option key={option.id} value={option.id}>{option.type}</option>
                    ))}
                  </select>

                  <input
                    type="number"
                    placeholder="кол."
                    className="textInput2EditingModal"
                    value={patchCableCount}
                    style={{width: '60px'}}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 0 || e.target.value === '') {
                        setPatchCableCount(e.target.value);
                      }
                    }}
                  />
                  <label className="textTitleDrawer" style={{fontSize: '16px', marginLeft:'5px'}}>шт.</label>
                  <br/>
                  <button onClick={updateCassettePatch} class='buttonIsSaveDialog2'>Сохранить</button>

                </div>
                </>
      )}
        <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.authorId}</span></label>
        <br/>
        <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
        <br/>
        <hr className='horizontalLineDialog'/>

        {content.cableTypeType === CONST_SUBWAY && (
          <>
           
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (акт приема): </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              value={textLengthAct} 
              min={0}
              onChange={handleLengthActChange} 
            /> м.
            <button onClick={updateHighwayLineLengthAct} class='buttonIsSaveDialog2'>Сохранить</button>

            <hr className='horizontalLineDialog2'/>
            
          </>
        )}

        <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: </label>
         
          <textarea
            className='textAreaEditingModal'
            value={textComment} 
            onChange={handleDescriptionChange} 
          />
          <button onClick={updateHighwayLineDescription} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className='horizontalLineDialog'/>

      <button  class='buttonIsEditDialog' onClick={handleClickEditLink}> Редактировать линк на карте</button>

      <hr className='horizontalLineDialog'/>
     
  <button 
    className="buttonIsDeleteModal" 
    onClick={deleteLink} 
    style={{ fontSize: "14px", width: "60px", padding: "2px", textShadow: '2px 2px 4px rgb(61, 61, 61)' }}
  >
    Удалить
  </button>

<hr className='horizontalLineDialog'/>
       
      </DialogContent>
  
      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>
  
       {/* Snackbar */}
       <Snackbar
           anchorOrigin={{
           vertical: 'bottom',
           horizontal: 'left',
           }}
           open={snackbarOpen}
           autoHideDuration={6000}
           onClose={handleCloseSnackbar}
           message={snackbarMessage}
           ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
            }
          }}
        />
 
    </Dialog>

  );
}

export default CableDescriptEditingModal;